/**
 * @fileOverview Fixed header
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Github:lodash-es/throttle
 * @requires Polyfill:element-prototype-classlist 'Element.classList'
 */

import throttle from 'lodash-es/throttle';

/**
 * fix .ac-menu
 * @function fixHeader
 */
function fixHeader() {
  // If the scroll is more than the height of the bridge
  // menu (32) + menu (80) minus 1
  if ( window.pageYOffset > 121 ) {
    document.querySelector( '.ac-menu.ac-menu--fixed' )
      .classList.add( 'js-menu-is--fixed' );
  } else {
    document.querySelector( '.ac-menu.ac-menu--fixed' )
      .classList.remove( 'js-menu-is--fixed' );
  }
}

/**
 * Export init function
 * @module initFixedHeader
 */
export default function initFixedHeader() {
  //check the selector is present
  let menu = document.querySelector( '.ac-menu.ac-menu--fixed' );
  if ( menu ) {
    window.addEventListener( 'scroll', throttle( fixHeader, 100 ));
  }
}
